import '@eroman/common/src/_base/lang/extensions';
import { Application } from './Application';

const app = new Application();
app.run();
